export const EnrollFromGTitle = [
    {
        label: "Title",
    },
    {label:'Mr'},
    {label:'Mrs'},
]
export const EnrollFromGGender = [
    {
        label: "Title",
        value: "title"
    },
    
]
export const Gender = [
    {label:'Male', value: "male"},
    {label:'Female', value: "female"},
]

export const countries = [
  { title: " Select Country" },
  { title: "Afghanistan" },
  { title: "Albania" },
  { title: "Algeria" },
  { title: "Andorra" },
  { title: "Angola" },
  { title: "Antigua and Barbuda" },
  { title: "Argentina" },
  { title: "Armenia" },
  { title: "Australia" },
  { title: "Austria" },
  { title: "Azerbaijan" },
  { title: "Bahamas" },
  { title: "Bahrain" },
  { title: "Bangladesh" },
  { title: "Barbados" },
  { title: "Belarus" },
  { title: "Belgium" },
  { title: "Belize" },
  { title: "Benin" },
  { title: "Bhutan" },
  { title: "Bolivia" },
  { title: "Bosnia and Herzegovina" },
  { title: "Botswana" },
  { title: "Brazil" },
  { title: "Brunei" },
  { title: "Bulgaria" },
  { title: "Burkina Faso" },
  { title: "Burundi" },
  { title: "Côte d'Ivoire" },
  { title: "Cabo Verde" },
  { title: "Cambodia" },
  { title: "Cameroon" },
  { title: "Canada" },
  { title: "Central African Republic" },
  { title: "Chad" },
  { title: "Chile" },
  { title: "China" },
  { title: "Colombia" },
  { title: "Comoros" },
  { title: "Congo (Congo-Brazzaville)" },
  { title: "Costa Rica" },
  { title: "Croatia" },
  { title: "Cuba" },
  { title: "Cyprus" },
  { title: "Czechia (Czech Republic)" },
  { title: "Democratic Republic of the Congo" },
  { title: "Denmark" },
  { title: "Djibouti" },
  { title: "Dominica" },
  { title: "Dominican Republic" },
  { title: "Ecuador" },
  { title: "Egypt" },
  { title: "El Salvador" },
  { title: "Equatorial Guinea" },
  { title: "Eritrea" },
  { title: "Estonia" },
  { title: "Eswatini (fmr. 'Swaziland')" },
  { title: "Ethiopia" },
  { title: "Fiji" },
  { title: "Finland" },
  { title: "France" },
  { title: "Gabon" },
  { title: "Gambia" },
  { title: "Georgia" },
  { title: "Germany" },
  { title: "Ghana" },
  { title: "Greece" },
  { title: "Grenada" },
  { title: "Guatemala" },
  { title: "Guinea" },
  { title: "Guinea-Bissau" },
  { title: "Guyana" },
  { title: "Haiti" },
  { title: "Holy See" },
  { title: "Honduras" },
  { title: "Hungary" },
  { title: "Iceland" },
  { title: "India" },
  { title: "Indonesia" },
  { title: "Iran" },
  { title: "Iraq" },
  { title: "Ireland" },
  { title: "Israel" },
  { title: "Italy" },
  { title: "Jamaica" },
  { title: "Japan" },
  { title: "Jordan" },
  { title: "Kazakhstan" },
  { title: "Kenya" },
  { title: "Kiribati" },
  { title: "Kuwait" },
  { title: "Kyrgyzstan" },
  { title: "Laos" },
  { title: "Latvia" },
  { title: "Lebanon" },
  { title: "Lesotho" },
  { title: "Liberia" },
  { title: "Libya" },
  { title: "Liechtenstein" },
  { title: "Lithuania" },
  { title: "Luxembourg" },
  { title: "Madagascar" },
  { title: "Malawi" },
  { title: "Malaysia" },
  { title: "Maldives" },
  { title: "Mali" },
  { title: "Malta" },
  { title: "Marshall Islands" },
  { title: "Mauritania" },
  { title: "Mauritius" },
  { title: "Mexico" },
  { title: "Micronesia" },
  { title: "Moldova" },
  { title: "Monaco" },
  { title: "Mongolia" },
  { title: "Montenegro" },
  { title: "Morocco" },
  { title: "Mozambique" },
  { title: "Myanmar (formerly Burma)" },
  { title: "Namibia" },
  { title: "Nauru" },
  { title: "Nepal" },
  { title: "Netherlands" },
  { title: "New Zealand" },
  { title: "Nicaragua" },
  { title: "Niger" },
  { title: "Nigeria" },
  { title: "North Korea" },
  { title: "North Macedonia" },
  { title: "Norway" },
  { title: "Oman" },
  { title: "Pakistan" },
  { title: "Palau" },
  { title: "Palestine State" },
  { title: "Panama" },
  { title: "Papua New Guinea" },
  { title: "Paraguay" },
  { title: "Peru" },
  { title: "Philippines" },
  { title: "Poland" },
  { title: "Portugal" },
  { title: "Qatar" },
  { title: "Romania" },
  { title: "Russia" },
  { title: "Rwanda" },
  { title: "Saint Kitts and Nevis" },
  { title: "Saint Lucia" },
  { title: "Saint Vincent and the Grenadines" },
  { title: "Samoa" },
  { title: "San Marino" },
  { title: "Sao Tome and Principe" },
  { title: "Saudi Arabia" },
  { title: "Senegal" },
  { title: "Serbia" },
  { title: "Seychelles" },
  { title: "Sierra Leone" },
  { title: "Singapore" },
  { title: "Slovakia" },
  { title: "Slovenia" },
  { title: "Solomon Islands" },
  { title: "Somalia" },
  { title: "South Africa" },
  { title: "South Korea" },
  { title: "South Sudan" },
  { title: "Spain" },
  { title: "Sri Lanka" },
  { title: "Sudan" },
  { title: "Surititle" },
  { title: "Sweden" },
  { title: "Switzerland" },
  { title: "Syria" },
  { title: "Tajikistan" },
  { title: "Tanzania" },
  { title: "Thailand" },
  { title: "Timor-Leste" },
  { title: "Togo" },
  { title: "Tonga" },
  { title: "Trinidad and Tobago" },
  { title: "Tunisia" },
  { title: "Turkey" },
  { title: "Turkmenistan" },
  { title: "Tuvalu" },
  { title: "Uganda" },
  { title: "Ukraine" },
  { title: "United Arab Emirates" },
  { title: "United Kingdom" },
  { title: "United States of America" },
  { title: "Uruguay" },
  { title: "Uzbekistan" },
  { title: "Vanuatu" },
  { title: "Venezuela" },
  { title: "Vietnam" },
  { title: "Yemen" },
  { title: "Zambia" },
  { title: "Zimbabwe" },
];

export const MaritalStatus = [
    { title: "Marital Status"},
    { title: "Married"},
    { title: "Divorced"},
    { title: "Single"}
]
export const CourseOption = [
    {title: "Front End Development (3months)"},
    {title: "Back End Development (3months)"},
    {title: "Full Stack Development (6months)"},
    { title: " Cyber Security (2days with exams)" },
  { title: "Cybersecurity Manager (5days with exams)" },
  { title: "Cloud Security Manager (5days with exams)" },
  { title: "Lead Ethical Hacker (5days with exams)" },
  { title: "Penetration Testing Professional (5days with exams)" },
  { title: "Computer Forensics (2days with exams)" },
  { title: "Lead Forensic Examiner (5days with exams)" },
  { title: "Agriculture And Food Security (6 weekends)" },
  { title: "Security And Risk Management (6 weekends)" },
  { title: "Blockchain And Cryptocurrency (6 weekends)" },
  { title: "Project And Brand Management (6 weekends)" },
  { title: "Early Childhood And Montessori Education (6 weekends)" },
  { title: "Business Start-Up And Entrepreneurship (6 weekends)" },
  { title: "Communication And Public Relations (6 weekends)" },
  { title: "Banking And Finance (4 Weekends)" },
  { title: "Project Management (4 Weekends)" },
  { title: "Strategic Management (4 Weekends)" },
  { title: "Marketing Management (4 Weekends)" },
  { title: "Security And Risk Management (4 Weekends)" },
  { title: "Human Resource Management (4 Weekends)" },
  { title: "Logistics And Supply Chain Management (4 Weekends)" },
  { title: "Occupational Health And Safety Management (4 Weekends)" },
];

export const DegreeCourses = [
  { title: "Human Resource" },
  { title: "Marketing/Public Relations" },
  { title: "Laundry Services" },
  { title: "Business Administration" },
  { title: "Accounting & Finance" },
];
export const Hnd = [
  { title: "Journalism & Media Studies" },
  { title: "Purchasing & Supply Management" },
  { title: "Commercial and Project Management" },
  { title: "Hospitality Management" },
];